import { render, staticRenderFns } from "./MyPaymentsList.vue?vue&type=template&id=0c6bc8d4"
import script from "./MyPaymentsList.vue?vue&type=script&lang=js"
export * from "./MyPaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports